module.exports = __webpack_public_path__ + "img/default_avatar_boy.248a855a.png";